import {
  Editor,
  Transforms,
  Node,
  Range
} from 'slate';

import types from '../../elements/types';

import HelptapEditor from '../../helpers';

export default function withCheckList(editor) {

  const { deleteBackward, insertBreak } = editor;

  editor.insertBreak = () => {
    const [match] = Editor.nodes(editor, {
      match(node) {
        return node.type === types.CHECK_LIST_ITEM;
      },
      mode: 'lowest'
    });

    if (match) {
      const [node] = match;
      if (Node.string(node) === '') {
        // Replace with default block and exit the list
        Transforms.setNodes(editor, HelptapEditor.paragraph.buildNode());
        return;
      }
    }

    insertBreak();
  };

  editor.deleteBackward = () => {

    const { selection } = editor;

    if (selection && Range.isCollapsed(selection)) {

      const [match] = Editor.nodes(editor, {
        match(node) {
          return node.type === types.CHECK_LIST_ITEM;
        },
        mode: 'lowest'
      });

      if (match) {
        const [node] = match;
        if (Node.string(node) === '') {
          // Exit list node to default block
          Transforms.setNodes(editor, HelptapEditor.paragraph.buildNode());
          return;
        }
      }

    }

    deleteBackward();
  };

  return editor;
};